import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect';
export default {
	name: 'Hub_Details',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		Multiselect
	},
	props: [],
	data() {
		return {
			Hub_Details:[],
			isLoading: false,
			isLoadingSearch: false,
			hubzoneid: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			HubID: '',
			hubname: '',
			DesHubID: '',
			DestHubName:'',
			listSourceHubNameData: [],
			listHubZoneData: [],
			listSourceHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listSourceHubNameDataObj2: {
				value: "",
				text: "",
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			},
			listConnectionNameDataObj: {
				value: "",
				text: ""
			},
			fncAction: '',
			hubLoading: '',
			HubName:[],
			destHub:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.getHubZoneData();
	},
	methods: {
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
			this.HubID = ''
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listSourceHubNameDataObj2 = {
				text: '',
				value: ''
			}
			this.DesHubID = ''
			this.$validator.reset()
			this.destHub=[]
			if (this.hubzoneid != undefined) {
				this.getSourceHubNameList(this.hubzoneid)
			}
		},
		selectedSourceHubName2(selectedData) {
			this.listSourceHubNameDataObj2 = selectedData
			this.DesHubID = selectedData.value;
			this.DestHubName = selectedData.text1;
			this.$validator.validate('DestinationHub')
		},
		selectedHubName(selectedData) {
			this.hubListObjData = selectedData
			this.HubID = selectedData.value;
			this.HubName = selectedData.text;
			this.getAllHubs();
		},
		selectedHubConnection(selectedData) {
			this.listConnectionNameDataObj = selectedData
			this.ConnectionID = selectedData.value;
			this.ConnectionName = selectedData.text;
			if (this.ConnectionID != undefined) {
				this.loadDisplayRoute()
			}
			this.$validator.validate('ConnectionID')
		},
		selectedSourceHubName(selectedData) {
			this.HubID = ''
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listSourceHubNameDataObj = selectedData
			this.HubID = selectedData.value;
			this.hubname = selectedData.text1;
			this.$validator.validate('SourceHub')
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},

		getSourceHubNameList() {
			this.hubLoading = 'Loading Hub...'
			this.listSourceHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameData = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameData.length; i++) {
						this.listSourceHubNameData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
							text1: listSourceHubNameData[i].HubName,
							hubcode: listSourceHubNameData[i].HubCode
						})
					}
				}, error => {
					console.error(error)
				})
		},
		getAllComboHubConfigurations() {
			this.pageNo = 0
			var isErr = 0;
			if (!this.hubzoneidflt) {
				this.isSearchHubZoneErr = '1',
					this.SearchHubZoneErr = 'The HubZone field is required.'
				isErr = 1;
			} else {
				this.isSearchHubZoneErr = '',
					this.SearchHubZoneErr = ''
			}
			if (isErr == 1) {
				return false;
			} else {
				this.getAllComboHubConfigurationsDetails();
			}
		},


		getHubDetailsData() {
      this.input = {
				id:this.DesHubID
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
						this.Hub_Details=result.data.ResponseData
          } else {
            this.hubcode = '';
          }
        }, error => {
          console.error(error)
        })
    },

		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm() {
			this.hubzoneid=''
			this.HubID=''
			this.DesHubID=''
			this.listSourceHubNameDataObj = {
				value: '',
				text: '',
				hubcode: ''
			};
			this.listHubZoneObjData = {
				value: '',
				text: ''
			};
			this.listConnectionNameDataObj = {
				value: '',
				text: ''
			};
			this.listResultHubobjData = {
				value: '',
				text: ''
			};
			this.listSourceHubNameDataObj2 = {
				value: '',
				text: ''
			}

			this.hubzoneid = '';
			this.HubID = '';
			this.ConnectionID = '';
			this.DesHubID = '';
			this.listSourceHubNameData = []
			this.Hub_Details = []
			this.$validator.reset();
			this.destHub=[]
		},
		closeStatusModal() {
			this.addmodalShow = false
		},
		takeAction() {
			this[this.fncAction]()
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/Hub_Details/Hub_Details.js